// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./$.export');
$export($export.S, 'Object', {setPrototypeOf: require('./$.set-proto').set});


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/es6.object.set-prototype-of.js
// module id = 1920
// module chunks = 0